<template>
    <div>
        <div class="row">
            <input-select class="col-12" label="Profissional/Equipe" v-model="form.pessoaId" :options="pessoas"/>
            <input-select class="col-12 col-md-6" label="Ano" v-model="form.ano" :options="anos"/>
            <input-select class="col-12 col-md-6" label="Mês" :disabled="!this.form.ano" v-model="form.mes" :options="mesesFiltrados"/>
        </div>
    </div>
</template>
<script>
import InputSelect from '@/components/inputs/InputSelect.vue';
import ProjetoGestaoService from "@/common/services/projeto_gestao/projeto_gestao.service";
import helpers from '@/common/utils/helpers';
export default {
    props : {
        projeto : {
            required : true
        }
    },
    components : {
        InputSelect
    },
    data : () => ({
        form : {
            pessoaId : null,
            ano : null,
            mes : null,
        },
        anos : [],
        meses : [],
        pessoas : [],
    }),
    methods : {
        getForm : function(){
            return {
                pessoaId : this.form.pessoaId,
                data : this.form.ano ? `${this.form.ano}-${this.form.mes}-01`: null
            };
        },  
        buscarPessoas : function(){
            ProjetoGestaoService.listarRH(
                this.projeto.id,
                true, 
                this.telaProponente ? "ProjetoGestao" : "ProjetoGestaoCooperada",
                this.telaProponente ? "ProjetoGestaoId" : "ProjetoGestaoCooperadaId",
            ).then(res => {
                this.pessoas = [
                    {value : null, text : "Toda a equipe"},    
                    ...(res.data.data.itens ? 
                        res.data.data.itens.length > 0 ? res.data.data.itens[0].equipe.alocacaoHorasIndividuais.map(el => {
                        return {
                            value : el.pessoa.id,
                            text : el.pessoa.nome
                        }
                    }) : [] : [])
                ];
            })
        },
        montarDatas: function(){
            this.meses = [
                {value : null, text : "Todos meses"},    
                ...helpers.retornarMeses()
            ];
            
            let anoInicio = parseInt(helpers.formatarData(this.projeto.dataInicio, 'YYYY'));
            let mesInicio = parseInt(helpers.formatarData(this.projeto.dataInicio, 'MM'));
            let duracao = this.projeto.duracao + mesInicio;
            
            this.anos.push({value : null, text : "Todos anos"})
            
            for (let i = 0; i < duracao / 12; i++) {
                
                this.anos.push({value : anoInicio + i , text : anoInicio + i })
            }
        }
    },
    mounted(){
        this.buscarPessoas();
        this.montarDatas();
    },
    computed : {
        mesesFiltrados : function(){
            
            return this.form.ano ? this.meses.filter(el => el.value != null) : this.meses
        },
        telaProponente :function(){
            return this.$route.name == 'projeto-gestao-proponente-detalhamento'
        },
    },
    watch : {
        "form.ano" : function(){
            if(this.form.ano){
                if(!this.form.mes)
                    this.form.mes = 1
            }else{
                this.form.mes = null;
            }
        }
    }
}
</script>
<style lang="">
    
</style>